import { Play, Pause } from "lucide-react";
import { useRadio, fmtTime } from "./RadioContext";

// THE standardized "▶ Hear it · 6:13" pill. Label comes from Admin → Radio → Button text unless overridden.
export const HEAR_IT_BASE = "inline-flex items-center gap-1.5 rounded-full ring-1 ring-[#54E3FF]/60 px-3.5 py-2 text-xs sm:text-sm font-black tracking-wide transition-colors";
export const HEAR_IT_CLS = `${HEAR_IT_BASE} bg-[#120A24] text-[#54E3FF] hover:bg-[#1b1333]`;

export const HearItButton = ({ onClick, time, label, title, active = false, className = "", testId }) => {
  const r = useRadio();
  const text = label || r.labels.hear_it;
  return (
    <button type="button" onClick={onClick} title={title} className={`${active ? `${HEAR_IT_BASE} bg-[#54E3FF] text-[#120A24] hover:bg-[#7eeaff]` : HEAR_IT_CLS} ${className}`} data-testid={testId}>
      {active ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}
      <span>{text}</span>
      {time != null && <span className="font-mono text-[11px] opacity-80">· {fmtTime(time)}</span>}
      {title && <span className="font-semibold normal-case tracking-normal opacity-90 truncate max-w-[14rem]">· {title}</span>}
    </button>
  );
};

// Plays a whole episode (a clip) from the start; shows pause while it's the one playing.
export const HearEpisodeButton = ({ episode, label, showTitle = true, className = "", testId }) => {
  const r = useRadio();
  const active = r.episode?.episode_id === episode.episode_id && r.playing;
  return (
    <HearItButton
      onClick={() => (r.episode?.episode_id === episode.episode_id ? r.toggle() : r.load(episode, 0))}
      time={episode.duration_sec || null} label={label} title={showTitle ? episode.title : undefined} active={active}
      className={className} testId={testId || `hear-episode-${episode.slug}`} />
  );
};
